import { trans } from "@mongez/localization";
import { Link } from "@remix-run/react";
import React from "react";
import { ChevronRight } from "~/design-system/components/icons";
import { BreadcrumbItem } from "~/design-system/types";

type BreadcrumbsProps = {
  title: string;
  image: string;
  items: BreadcrumbItem[];
};

export function Breadcrumbs({ title, image, items }: BreadcrumbsProps) {
  return (
    <div className="font-playfair relative">
      {/* Overlay */}
      <span className="absolute inset-0 z-10 bg-linear-to-br from-black/30 to-transparent to-70%"></span>
      {/* Image */}
      <img src={image} alt={title} className="h-[200px] w-full md:h-[300px]" />
      {/* Content */}
      <div className="absolute top-1/2 z-20 w-full -translate-y-1/2 text-white">
        <div className="container flex flex-col gap-3 md:gap-6">
          <div className="flex flex-wrap items-center gap-1 md:gap-2">
            {items.map((item, index) => {
              if (item.href) {
                return (
                  <React.Fragment key={index}>
                    <Link
                      to={item.href}
                      className="text-lg font-bold text-white hover:underline md:text-2xl"
                    >
                      {trans(item.text)}
                    </Link>
                    {index < items.length - 1 && (
                      <ChevronRight
                        color="#fff"
                        className="h-4 w-4 md:h-5 md:w-5"
                      />
                    )}
                  </React.Fragment>
                );
              }

              return (
                <React.Fragment key={index}>
                  <span className="text-lg md:text-2xl">
                    {trans(item.text)}
                  </span>
                  {index < items.length - 1 && (
                    <ChevronRight
                      color="#fff"
                      className="h-4 w-4 md:h-5 md:w-5"
                    />
                  )}
                </React.Fragment>
              );
            })}
          </div>
          {/* Title */}
          <h2 className="text-4xl font-extrabold md:text-6xl lg:text-7xl">
            {trans(title)}
          </h2>
        </div>
      </div>
    </div>
  );
}
